import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  getSelectedBusinessUnitFromLocal,
  getLocalUser,
} from '@/services/session-data';
import { ACCESS_TYPE_CLIENT } from '@/settings/consts/users';

const ChangeBusinessUnitDialog$: BehaviorSubject<any> = new BehaviorSubject(
  'initialize',
);

const STATUS_SHOW = 'show';
const STATUS_HIDE = 'hide';
export const STATUS_SELECT = 'select';

function businessUnitIsSelected(): void {
  getSelectedBusinessUnitFromLocal().subscribe((data) => {
    getLocalUser().subscribe((user) => {
      if (!data && user.tipoAcesso === ACCESS_TYPE_CLIENT) {
        show();
      }
    });
  });
}

function show(): void {
  ChangeBusinessUnitDialog$.next({status: STATUS_SHOW});
}

function close(): void {
  ChangeBusinessUnitDialog$.next({status: STATUS_HIDE});
}

function get(): Observable<any> {
  return ChangeBusinessUnitDialog$.pipe(filter((val) => val !== 'initialize'));
}

export function select(id): void {
  ChangeBusinessUnitDialog$.next({status: STATUS_SELECT, id});
}

export { businessUnitIsSelected, show, close, get, STATUS_SHOW, STATUS_HIDE };
